import { FormattedMessage } from 'react-intl';

import { supplierGridProperties } from '../../data/suppliers-properties';
import { messages } from '../messages';

type SupplierData = {
  contactPhone?: string;
};

const name = <FormattedMessage {...messages.supplierContactPhoneColumnHeader} />;

/**
 * Contact Phone column configuration
 * Displays the contact phone number for suppliers
 */
export const supplierContactPhone = {
  name,
  render: (data: SupplierData) => data.contactPhone,
  id: supplierGridProperties.contactPhone,
};
